import { lazyWithRetry } from "utils/lazy-with-retry";

export default lazyWithRetry(() => import("./Events"));
